//This service provides the operations for Chronicles.
import { handleResponse, Headers } from '../_helpers';

export const ChronicleService = {
  loadChronicle,
  saveChronicle,
  saveChronicleCalendar,
};

function loadChronicle({ chronicleID, worldID }) {
  const request = {
    method: 'GET',
    headers: Headers.set(),
  };

  return fetch(
    `${process.env.API_URL}/api/v1/chronicle/${chronicleID}`,
    request
  )
    .then(handleResponse)
    .then((response) => {
      // console.log('SERVICE', response);
      return response;
    });
}

function saveChronicle(chronicleID, chronicleData) {
  const request = {
    method: 'PATCH',
    headers: Headers.set(),
    body: JSON.stringify(chronicleData),
  };

  return fetch(
    `${process.env.API_URL}/api/v1/chronicle/${chronicleID}`,
    request
  )
    .then(handleResponse)
    .then((response) => {
      // console.log(response);
      return response;
    });
}

function saveChronicleCalendar(calendar) {
  const request = {
    method: 'POST',
    headers: Headers.set(),
    body: JSON.stringify(calendar),
  };

  return fetch(`${process.env.API_URL}/api/v1/calendar/new`, request)
    .then(handleResponse)
    .then((response) => {
      return response;
    });
}
